import React from 'react';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import { firebaseRoot } from './../../utils/firebase-utils';

import MobileHeader from '../../components/MobileHeader/MobileHeader';


import TouchButton from '../../components/TouchButton';
import TouchLink from '../../components/TouchLink';
import ImagePicker from '../../components/ImagePicker/ImagePicker';

import Glyphicon from 'react-bootstrap/lib/Glyphicon';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Tooltip from 'react-bootstrap/lib/Tooltip';
import Modal from 'react-bootstrap/lib/Modal';
import Input from 'react-bootstrap/lib/Input';

import FormSection from '../../components/FormSection/FormSection';
import FormGroup from '../../components/FormGroup/FormGroup';

const SignupProfile = React.createClass({
	mixins: [LinkedStateMixin],

	contextTypes: {
		history: React.PropTypes.object.isRequired,
		userRef: React.PropTypes.object
	},

	getInitialState() {
		return {
			birthday: this.context.userRef.val().birthday,
			firstname: this.context.userRef.val().firstname,
			lastname: this.context.userRef.val().lastname,
			gender: this.context.userRef.val().gender
		}
	},

	nextStep(e) {
		e.preventDefault();
		this.context.history.pushState(null, '/signup/school', null);
	},

	render() {
		return (
			<div className="screen-wrap">
				<MobileHeader
						lessonId={this.props.params.lessonId}
						problemId={this.props.params.problemId}
						bookId={this.props.params.bookId}
						type='signupSteps'
				        title='Profile'
				        step="profile"
						// Don't show the back button on the root screen.
						backButton={this.props.location.pathname.length > 1}
				/>
				<div className="screen-content">
					<form className="section-wrap" onSubmit={this.nextStep}>
						<div className="section-body">
							<div className="signup-imagepicker">
								<ImagePicker/>
							</div>
							<div className="">
								<FormSection>
									<FormGroup
										label="First name"
									>
										<Input type="text" valueLink={this.userLinkState('firstname')}/>
									</FormGroup>
									<FormGroup
										label="Last name"
									>
										<Input type="text" valueLink={this.userLinkState('lastname')}/>
									</FormGroup>
									<FormGroup
										label="Date of birth"
									>
										<Input type="date" valueLink={this.userLinkState('birthday')}/>
									</FormGroup>
									<FormGroup
										label="Gender"
									>
										<Input type="select" valueLink={this.userLinkState('gender')}>
											<option value="m">Male</option>
											<option value="f">Female</option>
										</Input>
									</FormGroup>
								</FormSection>


							</div>
						</div>
						<div className="section-footer">
							<TouchButton type="submit" bsStyle="primary" bsSize="large" block>Next</TouchButton>
						</div>
					</form>
				</div>
			</div>
		);
	},

	userLinkState(name) {
		return {
			value: this.state[name],
			requestChange: (newValue) => {
				this.setState({[name]: newValue});
				this.context.userRef.ref().child(name).set(newValue).then(
					null, window.alert
				);
			}
		}
	}
});

export default SignupProfile;


/** WEBPACK FOOTER **
 ** ./src/screens/signup/SignupProfile.js
 **/